export default Object.freeze({
  UNSET: 0,
  ADDITIONAL_INFORMATION: 1,
  CONTRACT_STATUS_HISTORY: 2,
  CONTRACT_HISTORY: 3,
  VISIT_DETAILS: 4,
  DETERMINATION: 5,
  MODIFY_APPROVAL_DATE: 8,
  CONTRACT_ADDITIONAL_DOCUMENTS: 9,
  EVALUATION_DOCUMENTS: 10,
  COMPENSATORY_THERAPY_BALANCE: 11,
  CONTRACT_DOCUMENT_HISTORY: 12,
  CONTRACT_AEE: 13,
  COMPENSATORY_REQUEST: 14,
  SIGNATURE_DETAIL: 15,
  CONTRACT_COST_CHANGE_HISTORY: 16,
});
